var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { range } from 'tss-core-lib-common';
import { IMG_ICON_FILE_BLUE_LARGE, Icon } from '..';

var styles = void 0;

var FileUploadProgress = function (_Component) {
  _inherits(FileUploadProgress, _Component);

  function FileUploadProgress() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FileUploadProgress);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileUploadProgress.__proto__ || Object.getPrototypeOf(FileUploadProgress)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      count: 0
    }, _this.setRef = function (ref) {
      _this.ref = ref;
    }, _this.update = function () {
      if (!_this.state.height) {
        var _this$ref$getBounding = _this.ref.getBoundingClientRect(),
            height = _this$ref$getBounding.height,
            width = _this$ref$getBounding.width;

        if (height && width) {
          var divisor = Math.round(width / 4);
          var rows = Math.round(height / divisor);
          var columns = Math.round(width / divisor);
          var nrOfDots = rows * columns;

          _this.setState({
            height: height,
            width: width,
            rows: rows,
            columns: columns,
            divisor: divisor,
            nrOfDots: nrOfDots,
            maxDots: Math.round(Math.round(columns + columns / 2))
          });
        }
      } else {
        _this.setState({ count: _this.state.count + 1 });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FileUploadProgress, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.timer = setInterval(this.update, 75);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        { className: css(styles.container), ref: this.setRef },
        React.createElement(Icon, { src: IMG_ICON_FILE_BLUE_LARGE }),
        React.createElement(
          'div',
          { className: css(styles.dotContainer) },
          this.state.maxDots ? range(this.state.count, this.state.count + this.state.maxDots).map(function (i) {
            var x = i % _this2.state.columns * _this2.state.divisor;
            var y = Math.floor(i / _this2.state.columns) % _this2.state.rows * _this2.state.divisor;
            return React.createElement('div', {
              key: x + ',' + y,
              className: css(styles.dot),
              style: {
                backgroundColor: _this2.props.backgroundColor,
                width: _this2.state.divisor,
                height: _this2.state.divisor,
                top: y,
                left: x
              }
            });
          }) : null
        )
      );
    }
  }]);

  return FileUploadProgress;
}(Component);

FileUploadProgress.propTypes = {
  backgroundColor: PropTypes.string
};
FileUploadProgress.defaultProps = {
  backgroundColor: 'white'
};


styles = StyleSheet.create({
  container: {
    position: 'relative'
  },

  dotContainer: {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },

  dot: {
    position: 'absolute'
  }
});

export default FileUploadProgress;